export const selectActiveFilters = (state) => state.filters.activeFilters ?? [];
